import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

// Forward ref to allow smooth scrolling
const Footer = React.forwardRef((props, ref) => {
  return (
    <footer
      ref={ref}
      id="footer"
      className="bg-brandRed text-white px-6 py-12 mt-[4rem]"
    >
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-center lg:text-left">
        {/* Location Section */}
        <div className="flex flex-col h-full justify-start items-center lg:items-start w-full lg:w-[350px] lg:ml-[180px]">
          <h2 className="text-2xl font-bold mb-4 border-b-2 border-white w-fit mx-auto lg:mx-[50px]">
            Location
          </h2>
          <a
            href="https://maps.app.goo.gl/shZZUFaLGeB6Ycir6"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col lg:flex-row items-center lg:items-start text-md text-white hover:text-gray-200 transition-colors max-w-[300px] mx-auto lg:mx-0"
          >
            <FaMapMarkerAlt className="mb-3 lg:mb-0 lg:mr-3 text-white" size={120} />
            <span>
              Address: Janhith Office, Near Nanbhat Talav, St.Paul Church, Po. Sopara,
              Pin-401203, Tal.-Vasai, Dist.-Palghar, Maharashtra.
            </span>
          </a>
        </div>

        {/* Quick Links Section */}
        <div className="flex flex-col h-full justify-start items-center lg:items-start lg:ml-[150px]">
          <h2 className="text-2xl font-bold mb-4 border-b-2 border-white w-fit mx-auto lg:mx-0 pb-1">
            Quick Links
          </h2>
          <ul className="mt-2 space-y-3 text-lg">
            <li>
              <a href="/" className="text-white hover:underline hover:text-gray-200">
                Home
              </a>
            </li>
            <li>
              <a href="/event" className="text-white hover:underline hover:text-gray-200">
                Events
              </a>
            </li>
            <li>
              <a href="/gallery" className="text-white hover:underline hover:text-gray-200">
                Gallery
              </a>
            </li>
            <li>
              <a
                href="https://forms.gle/L5LzaPyM5tRgtQ1i9"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:underline hover:text-gray-200 font-semibold inline-flex items-center gap-1"
              >
                Marathon Registration ↗
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="flex flex-col h-full justify-start items-center lg:items-start lg:ml-[90px]">
          <h2 className="text-2xl font-bold mb-4 border-b-2 border-white w-fit mx-auto lg:mx-0 pb-1">
            Contact
          </h2>
          <p className="text-lg mt-2 text-white">Email: info@nanbhatjanhithsociety.com</p>
          <p className="text-lg mt-2 text-white">Phone: +91 9881827232</p>
          <p className="text-lg mt-2 text-white">Phone: +91 8796667978</p>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="text-center text-lg mt-10 border-t border-white pt-4 text-white">
        &copy; {new Date().getFullYear()} Nanbhat Janhith Society. All rights reserved.
      </div>
    </footer>
  );
});

export default Footer;
